import React from 'react'
import { Swiper } from "swiper/react"
import { Navigation } from "swiper/modules";

interface ISliderProps {
    children: React.ReactNode;
    sliderStyle?: React.CSSProperties;
}

export const SwiperSlider = ({ children, sliderStyle = {} }: ISliderProps) => {
    return (
        <Swiper style={sliderStyle}
            className="swiper-properties s1"
            modules={[Navigation]}
            spaceBetween={10}
            slidesPerView={"auto"}     // ✅ important (fixed width slides)
            slidesPerGroup={1}         // ✅ next button moves 1 card
            navigation={true}
            grabCursor={true}
            simulateTouch={true}
            threshold={5}
            watchOverflow={true}
            breakpoints={{
                0: {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: "auto",
                    slidesPerGroup: 1,
                    spaceBetween: 12,
                },
                1067: {
                    slidesPerView: 3,      // ✅ desktop shows 3 full cards
                    slidesPerGroup: 1,     // keep 1 if you want step-by-step
                    spaceBetween: 10,
                },
            }}
        >
            {children}
        </Swiper>
    )
}
